const DISMISS_DURATION_MS = 60_000;

let inMemoryHiddenUntil = 0;

function dismissNewVersionModal(modal: HTMLElement) {
  modal.style.setProperty('display', 'none');
  inMemoryHiddenUntil = Date.now() + DISMISS_DURATION_MS;
  window.setTimeout(() => {
    inMemoryHiddenUntil = 0;
    showNewVersionModal();
  }, DISMISS_DURATION_MS);
}

export function showNewVersionModal() {
  if (Date.now() < inMemoryHiddenUntil) {
    return;
  }
  const modal = document.getElementById('new-version-available-modal');
  if (!modal) {
    return;
  }
  const dismissButton = modal.querySelector<HTMLElement>(
    '#new-version-dismiss-btn'
  );
  if (dismissButton) {
    dismissButton.onclick = () => dismissNewVersionModal(modal);
  }
  modal.style.setProperty('display', 'flex');
}

/**
 * Re-usable middleware for checking if a new version of the app is available.
 * Used for both ky and fetch clients.
 * @param response Response
 * @returns Response
 */
export function newVersionMiddleware(response: Response) {
  const remoteConfigVersion = response.headers.get('x-version');
  if (!remoteConfigVersion || VERSION_NUMBER === null) {
    return response;
  }
  if (parseInt(remoteConfigVersion) > parseInt(VERSION_NUMBER)) {
    showNewVersionModal();
  }
  return response;
}
